import axios from 'axios'
import { Message } from 'element-ui'
// import qs from 'qs'

import { baseURL } from '@/utils/baseURL.js'

const service = axios.create({
  baseURL: baseURL,
  timeout: 1000 * 60 * 1
})

service.interceptors.request.use(
  config => {
    // if (config.method === 'post') config.data = qs.stringify(config.data)
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    if (error.message.indexOf('timeout') > -1) {
      Message({
        message: '请求超时, 请稍候重试',
        type: 'error',
        duration: 2 * 1000
      })
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 2 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
